import DisputeManagement from 'src/components/BeaconV2Components/ExperimentalLayout/Finance/DisputeManagement/DisputeManagement';

export const buildDisputeManagementPageWidgets = (widgets) => {
  widgets.push({
    CustomComponent: DisputeManagement,
    data: {},
    view: {}
  });
};
